import React from 'react';
import { Icon, StandAloneLink } from '@hz-design-system/web-ui';
import { useI18nContext } from '@ecg-marktplaats/js-react-i18n';
import { TListingClient } from 'types/TListing';
import Classes from './BusinessSellerBuyNowInfo.module.scss';

interface IBusinessSellerBuyNowInfoProps {
  listing: TListingClient;
}

export const BusinessSellerBuyNowInfo = ({ listing }: IBusinessSellerBuyNowInfoProps) => {
  const { t } = useI18nContext();
  const termsAndConditionsUrl = `/smb-profile/profile/${listing.seller.id}/terms-and-conditions`;

  return (
    <div className={Classes.container}>
      <div className={Classes.protectionContainer}>
        <Icon name="veilig-handelen" color="background-info-default" />
        <span className={Classes.infoLabel}>{t('businessSeller.buyerProtection')}</span>
      </div>
      <div className={Classes.reflectionPeriodContainer}>
        <Icon name="warranty" color="background-info-default" />
        <span className={Classes.infoLabel}>{t('businessSeller.reflectionPeriod')}</span>
      </div>
      <div className={Classes.termsAndConditionsLinkContainer}>
        <StandAloneLink href={termsAndConditionsUrl} iconLeft="shop" className={Classes.termsAndConditionsLink}>
          {t('businessSeller.termsAndConditions')}
        </StandAloneLink>
      </div>
    </div>
  );
};
